import { useMemo } from "react";
import { bool, func, node, oneOf, string } from "prop-types";
import { observer } from "mobx-react";
import {
  usePresetFieldNames,
  useEstimateTableSettings,
  useEstimateEditorSettings,
  PinnableCell,
  ExpandContainer,
  DragHandleCell,
} from "@tools";
import { capitalize, Grid } from "@material-ui/core";
import classnames from "classnames";
import useStyle from "./TimelineMenuTitle.style";

export const TimelineMenuTitle = observer(({
  code,
  actions,
  children,
  className,
  isFirst,
  ...expandProps
}) => {
  const { isProposal, isPdfPrinterView } = useEstimateEditorSettings();
  const { fullSectionActions } = useEstimateTableSettings();
  const { getFieldName } = usePresetFieldNames(isProposal);
  const classes = useStyle();
  
  const ptClass = useMemo(() => `pt-timeline${capitalize(code)}`, [code]);
  
  return (
    <Grid
      item container
      wrap="nowrap"
      className={classnames("bg-secondary preset-page", className)}
    >
      {
        !isPdfPrinterView && <DragHandleCell />
      }
      <PinnableCell
        hasStaticWidth
        allowOverflowDisplay
        wider={fullSectionActions}
        containers={
          <ExpandContainer
            presetClassName="preset-timelineSubHeader"
            {...expandProps}
          />
        }
        className={classnames(isFirst && classes.firstPadding)}
        actions={actions}
      >
        <Grid item container alignItems="center">
          <h3 className={classnames("capitalize preset-timelineSubHeader", ptClass, children && "mr-2")}>
            { getFieldName(ptClass) }
          </h3>
          { children }
        </Grid>
      </PinnableCell>
    </Grid>
  );
});

TimelineMenuTitle.propTypes = {
  code: oneOf(["sections", "utilization", "billing"]).isRequired,
  actions: node,
  children: node,
  expandable: bool,
  expanded: bool,
  onExpand: func,
  className: string,
  isFirst: bool,
};
